import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { ReactNode } from 'react';

interface IProps {
  title?: string;
  content?:(() => ReactNode) | string;
  isOpen: boolean;
  hasActions?: boolean;
  agree?: () => void;
  disAgree?: () => void;
  handleClose?: () => void ;
  buttonText?: string;
}
class AlertDialog extends React.Component<IProps> {
  render() {
    const {
      title,
      content,
      disAgree,
      agree,
      isOpen,
      handleClose,
      hasActions,
      buttonText,
    } = this.props;
    let displayContent;
    if (content) {
      if (typeof content !== 'string') {
        displayContent = content();
      }  else {
        displayContent = content;
      }
    } else {
      displayContent =  ' Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.';
    }
    return (
      <div>
        <Dialog
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {title || 'Wadi Degla Dashboard'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {displayContent || ' Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.'}
            </DialogContentText>
          </DialogContent>
          { hasActions
            ? (
              <DialogActions>
                <Button onClick={disAgree} color="primary">
                Disagree
                </Button>
                <Button onClick={agree} color="primary" autoFocus>
                Agree
                </Button>
              </DialogActions>
            )
            : (
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  {buttonText}
                </Button>
              </DialogActions>
            )}
        </Dialog>
      </div>
    );
  }
}

export default AlertDialog;
